<template>
  <AccordionTab>
    <slot name="header" />
    <slot name="default" />
  </AccordionTab>
</template>

<script>
import AccordionTab from 'primevue/accordiontab';

export default {
  name: 'AccordionTabWrapper',
  components: {
    AccordionTab,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
  },
};
</script>
